export const FETCH_ALL_LINKED_CATEGORIES = {
  REQUEST: "FETCH_ALL_LINKED_CATEGORIES_REQUEST",
  SUCCESS: "FETCH_ALL_LINKED_CATEGORIES_SUCCESS",
  FAILURE: "FETCH_ALL_LINKED_CATEGORIES_FAILURE",
};

export const ADD_LINKED_CATEGORIES_SET = {
  REQUEST: "ADD_LINKED_CATEGORIES_SET_REQUEST",
  SUCCESS: "ADD_LINKED_CATEGORIES_SET_SUCCESS",
  FAILURE: "ADD_LINKED_CATEGORIES_SET_FAILURE",
};

export const RESET_UPLOAD_SUCCESS = "RESET_UPLOAD_SUCCESS";
export const LINKED_CATEGORIES_SERVICE_URL =
  "LOAD_LINKED_CATEGORIES_SERVICE_URL";

export const FETCH_LINKED_CATEGORY_SET_BY_CATEGORY = {
  REQUEST: "FETCH_LINKED_CATEGORY_SET_BY_CATEGORY_REQUEST",
  SUCCESS: "FETCH_LINKED_CATEGORY_SET_BY_CATEGORY_SUCCESS",
  FAILURE: "FETCH_LINKED_CATEGORY_SET_BY_CATEGORY_FAILURE",
};

export const LINKED_CATEGORY_SET_NOT_FOUND = "LinkedCategorySetNotFound";

export const RESET_LINKED_CATEGORY_DATA = "RESET_LINKED_CATEGORY_DATA";

export const SEARCH_LINKED_CATEGORIES = {
  REQUEST: "SEARCH_LINKED_CATEGORIES_REQUEST",
  SUCCESS: "SEARCH_LINKED_CATEGORIES_SUCCESS",
  FAILURE: "SEARCH_LINKED_CATEGORIES_FAILURE",
};

export const CLEAR_LINKED_CATEGORY_SEARCH = "CLEAR_LINKED_CATEGORY_SEARCH";

export interface CategoryLabel {
  code: string;
  catalogCode: string;
  storeCode: string;
}

export const FETCH_LINKED_CATEGORY_CODES = {
  REQUEST: "FETCH_LINKED_CATEGORY_CODES_REQUEST",
  SUCCESS: "FETCH_LINKED_CATEGORY_CODES_SUCCESS",
  FAILURE: "FETCH_LINKED_CATEGORY_CODES_FAILURE",
};

export interface LinkedCategoryCodesAction {
  type: typeof FETCH_LINKED_CATEGORY_CODES.REQUEST;
  payload: { categories: LinkedCategoryEntry[] };
}

export type LinkedCategoryPane = "target" | "source";

export interface CategorySearchResult {
  categoryId: string;
  catalogId: string;
  storeId: string;
  name?: string;
  code: string;
  catalogCode: string;
  storeCode: string;
}

export interface LinkedCategorySearchRequest {
  pane: LinkedCategoryPane;
  storeId: string;
  catalogId: string;
  startsWith: string;
  limit?: number;
}

export interface LinkedCategorySearchAction {
  type: typeof SEARCH_LINKED_CATEGORIES.REQUEST;
  payload: LinkedCategorySearchRequest;
}

export interface ClearLinkedCategorySearchAction {
  type: typeof CLEAR_LINKED_CATEGORY_SEARCH;
  payload: { pane: LinkedCategoryPane };
}

export interface LinkedCategoryEntry {
  catalogId: string;
  categoryId: string;
  storeId: string;
}

export interface LinkedCategory {
  linkedCategorySetId: string;
  categories: {
    catalogId: string;
    categoryId: string;
    storeId: string;
  }[];
}

export interface LinkedCategorySetsRequest {
  linkedCategorySets: LinkedCategory[];
}

export interface LinkedCategorySetsRequestAction {
  type: typeof ADD_LINKED_CATEGORIES_SET.REQUEST;
  payload: LinkedCategorySetsRequest;
}

export interface LinkedCategorySetByCategoryRequest {
  catalogId: string;
  categoryId: string;
}

export interface LinkedCategorySetByCategoryAction {
  type: typeof FETCH_LINKED_CATEGORY_SET_BY_CATEGORY.REQUEST;
  payload: LinkedCategorySetByCategoryRequest;
}
